import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../../environments/environement';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable, of } from 'rxjs';
import { EleveDTO } from '../../../models/EleveDTO';

@Injectable({
  providedIn: 'root'
})
export class ElevesService {
  baseUrl = environment.apiUrl + '/eleves';

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  private getAuthHeaders(): { [header: string]: string } {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('presence');
      return token ? { Authorization: `Bearer ${token}` } : {};
    }
    return {};
  }

  getUnassignedElevesByAge(age: number): Observable<EleveDTO[]> {
    const etablissementId = localStorage.getItem('etablissementId');
  
    if (!etablissementId) {
      // Si aucun établissement n’est trouvé, retourne une liste vide
      return of([]);
    }
  
    const url = `${this.baseUrl}/eleves/unassigned-age-${age}?etablissementId=${etablissementId}`;
    return this.http.get<EleveDTO[]>(url, this.getAuthHeaders());
  }
  

  removeEleveFromClasse(eleveId: number): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.delete(`${this.baseUrl}/${eleveId}/classe`, { headers });
  }

  getElevesByParentId(parentId: number): Observable<EleveDTO[]> {
    const headers = this.getAuthHeaders();
    return this.http.get<EleveDTO[]>(`${this.baseUrl}/parParent/${parentId}`, { headers });
  }


  getNonAffectedEleves(): Observable<EleveDTO[]> {
    const etablissementId = localStorage.getItem('etablissementId');
  
    if (!etablissementId) {
      return of([]); // Retourne une liste vide si non défini
    }
  
    const url = `${this.baseUrl}/non-affectes?etablissementId=${etablissementId}`;
    return this.http.get<EleveDTO[]>(url, { headers: this.getAuthHeaders() });
  }
  
  
}
